var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    width: 55.9483,
    height: 55,
    rx: 9.04036,
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6139 21.9794C24.284 17.406 31.854 17.406 36.5301 21.9794L37.092 22.5292C37.3276 22.7587 37.3276 23.1273 37.092 23.3568L35.1708 25.2418C35.056 25.3566 34.8627 25.3566 34.7479 25.2418L33.9746 24.4866C30.7182 21.2967 25.4319 21.2967 22.1755 24.4866L21.3478 25.2962C21.233 25.411 21.0397 25.411 20.9249 25.2962L18.9977 23.4112C18.7621 23.1816 18.7621 22.8131 18.9977 22.5835L19.6139 21.9794ZM40.5055 25.8701L42.2152 27.5436C42.4508 27.7732 42.4508 28.1417 42.2152 28.3713L34.5002 35.9292C34.2646 36.1588 33.89 36.1588 33.6544 35.9292L28.1747 30.5644C28.1143 30.51 28.0237 30.51 27.9633 30.5644L22.4897 35.9292C22.2541 36.1588 21.8795 36.1588 21.6439 35.9292L13.9228 28.3773C13.6872 28.1478 13.6872 27.7792 13.9228 27.5497L15.6326 25.8762C15.8682 25.6466 16.2427 25.6466 16.4784 25.8762L21.958 31.241C22.0184 31.2954 22.1091 31.2954 22.1695 31.241L27.6431 25.8762C27.8787 25.6466 28.2533 25.6466 28.4889 25.8762L33.9685 31.241C34.029 31.2954 34.1196 31.2954 34.18 31.241L39.6596 25.8762C39.8892 25.6405 40.2698 25.6405 40.5055 25.8701Z",
    fill: "#3A99FB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.8bb7c2318271d685f74d9799e09b19d2.svg";
export { ForwardRef as ReactComponent };